/* Bundle cart trigger — Cornerstone theme — final */
window.cbOpenQuickCart = function(addedItem) {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {

      /* 1 — Update cart count badge in header right away */
      document.querySelectorAll(
        '.header__cart-link-count, [data-cart-count], .cart-count, .header__icon-count'
      ).forEach(function(el) {
        el.textContent = cart.item_count;
      });

      /* 2 — Fire Cornerstone's own cart events so the theme updates internally */
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { product: addedItem || {} } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('quick-cart:open', { bubbles: true, detail: { cart: cart } }));

    })
    .catch(function(e) { console.warn('cbOpenQuickCart:', e); });
};

/* ================================================================
   Buy 3 Get 1 Free widget — cart sync
   ----------------------------------------------------------------
   bxgy-progress-bar.liquid is rendered server-side, so its markup
   (progress bar, eligible count, remaining-needed copy, "Offer
   Unlocked" state) only reflects the cart at the moment the page
   was last rendered. It was not being re-rendered on any AJAX cart
   change, so it could keep showing "Offer Unlocked" after items
   were removed, or fail to update after items were added.

   This re-fetches whichever section(s) actually contain the widget
   (quick cart drawer and/or full cart page — found dynamically via
   each widget's own data-section-id ancestor, so this works no
   matter which sections the widget happens to be placed in) and
   swaps in the freshly rendered widget node, keeping it perfectly
   in sync with the live cart state at all times.
   ================================================================ */
(function() {
  var bxgyRefreshInFlight = false;
  var bxgyRefreshQueued = false;

  function refreshBxgyWidgets() {
    if (bxgyRefreshInFlight) {
      bxgyRefreshQueued = true;
      return;
    }

    var widgetEls = document.querySelectorAll('[data-bxgy-widget]');
    if (!widgetEls.length) return;

    var sectionIds = [];
    widgetEls.forEach(function(widgetEl) {
      var sectionEl = widgetEl.closest('[data-section-id]');
      var id = sectionEl && sectionEl.getAttribute('data-section-id');
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });
    if (!sectionIds.length) return;

    bxgyRefreshInFlight = true;

    fetch('/?sections=' + sectionIds.join(','))
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        sectionIds.forEach(function(id) {
          var html = sections[id];
          if (!html) return;

          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var freshWidget = tmp.querySelector('[data-bxgy-widget]');
          var sectionEl = document.querySelector('[data-section-id="' + id + '"]');
          var currentWidget = sectionEl && sectionEl.querySelector('[data-bxgy-widget]');

          if (freshWidget && currentWidget) {
            currentWidget.replaceWith(freshWidget);
          }
        });
      })
      .catch(function(e) { console.warn('refreshBxgyWidgets:', e); })
      .then(function() {
        bxgyRefreshInFlight = false;
        if (bxgyRefreshQueued) {
          bxgyRefreshQueued = false;
          refreshBxgyWidgets();
        }
      });
  }

  /* Theme-dispatched cart events (see assets/custom-events.js):
       - cart:updated      fires on every cart mutation: add, remove,
                            quantity increase/decrease — this is the
                            theme's general-purpose "cart changed" hook
       - cart:item-added   fires specifically when an item is added
                            (covers the custom bundle add-to-cart flow)
       - quick-cart:open   fires when the drawer opens, so the widget
                            self-heals even if it was rendered stale
                            before the customer reopens the drawer */
  ['cart:updated', 'cart:item-added', 'quick-cart:open'].forEach(function(evtName) {
    document.addEventListener(evtName, refreshBxgyWidgets);
  });

  /* Safety net: also catch direct Ajax Cart API calls (/cart/add.js,
     /cart/change.js, /cart/update.js, /cart/clear.js) in case any cart
     interaction in the theme (e.g. a quantity stepper or remove button)
     ever mutates the cart without dispatching one of the events above. */
  if (!window.__bxgyFetchPatched) {
    window.__bxgyFetchPatched = true;
    var originalFetch = window.fetch;

    window.fetch = function() {
      var request = originalFetch.apply(this, arguments);
      var firstArg = arguments[0];
      var url = (firstArg && firstArg.url) || firstArg || '';

      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        request.then(function(response) {
          if (response && response.ok) refreshBxgyWidgets();
          return response;
        }).catch(function() {});
      }

      return request;
    };
  }
})();

/* Also patch into Cornerstone's own add-to-cart flow so cart refreshes */
document.addEventListener('DOMContentLoaded', function() {
  /* Watch for our bundle items being added and re-render quick cart content */
  document.addEventListener('cart:item-added', function() {
    /* Re-render quick cart items section */
    var qcSection = document.querySelector('[data-section-type="quick-cart"]');
    if (qcSection && typeof window.Shopify !== 'undefined') {
      fetch('/?sections=quick-cart')
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          if (sections['quick-cart']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = sections['quick-cart'];
            var newContent = tmp.querySelector('.quick-cart__items');
            var oldContent = qcSection.querySelector('.quick-cart__items');
            if (newContent && oldContent) oldContent.innerHTML = newContent.innerHTML;
            var newTotal = tmp.querySelector('.quick-cart__footer-subtotal');
            var oldTotal = qcSection.querySelector('.quick-cart__footer-subtotal');
            if (newTotal && oldTotal) oldTotal.innerHTML = newTotal.innerHTML;
          }
        });
    }
  });
});
